import GeneralKenticoForm from './form-general-kentico';
import { AzureFileUploadHelper } from '../azure-file-upload-helper';

class GeneralKenticoFileUploadForm extends GeneralKenticoForm {
    constructor(config) {
        super(config);
        this.getPostDataCallback = this.addPostData.bind(this);
        this.config = config;
        
        // Example fileConfig - FOR REFERENCE ONLY
        // this.config.fileUpload = {
        //     fileInputFieldIds: ["file1", "file2", "file3"],
        //     isLoggedInMSHUserRequired: true,
        //     adId: obj.adId,
        //     lotCostCenterId: obj.lotCostCenter,
        //     storageContext: "warranty-request-public-non-prod"
        // }

        this.azFileUploadHelper = AzureFileUploadHelper();
        if (this.config.fileUpload)
        {
            this.config.fileUpload.uploadFileCallback = this.uploadFiles.bind(this);
        }
    }

    //-------------------------------------------------------------------------------------------------
    // Called by the base class to update/modify fields in postData object.
    // The code below adds the file urls to the postData.
    //-------------------------------------------------------------------------------------------------
    addPostData(postData) {
        postData.fileattachmenturls = [];
        var files = [];
        for (var key in this.azFileUploadHelper.filesUploaded) {
            files.push(this.azFileUploadHelper.filesUploaded[key]);
        }
        for (var key in files) {
            postData.fileattachmenturls.push(files[key].uri);
        }
        return postData;
    }

    //-------------------------------------------------------------------------------------------------
    // Called from the base class during the onSubmitClick to allow the files to be updates.
    // This function returns a promise.
    //-------------------------------------------------------------------------------------------------
    uploadFiles(clsInstance)
    {
        return new Promise(function(resolve, reject){
            try
            {
                clsInstance.azFileUploadHelper.initialize(clsInstance.config.fileUpload);
                clsInstance.azFileUploadHelper.uploadFiles(function (result, message, rspObj) {
                    if (result && resolve) {
                        resolve(rspObj) // can be null
                    }
                    else if (rspObj && reject) {
                        reject(rspObj);
                    };
                }, clsInstance.onUploadProgress);
            }
            catch (err)
            {
                if (reject) reject();
            }
        });
    }

    //-------------------------------------------------------------------------------------------------
    // Called by fileuploadhelper to show upload progress
    //-------------------------------------------------------------------------------------------------
    onUploadProgress(progress)
    {
        // UI currently does not display the progress
    }
}

export { GeneralKenticoFileUploadForm as default }
